import { render, staticRenderFns } from "./StockDetailPurchaseLogin.vue?vue&type=template&id=b9a34762&scoped=true&"
import script from "./StockDetailPurchaseLogin.vue?vue&type=script&lang=js&"
export * from "./StockDetailPurchaseLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a34762",
  null
  
)

export default component.exports